import { AiProcessExecutionStatus, AiProcessStepExecutionStatus } from 'constants/aiProcessRuns';
import { COLOR_PALETTE } from 'constants/ui';

export const StatusIconAppearance = {
  [AiProcessExecutionStatus.COMPLETED]: {
    backgroundColor: COLOR_PALETTE.GREEN[6],
    label: 'Done',
  },
  [AiProcessExecutionStatus.FAILED]: {
    backgroundColor: COLOR_PALETTE.RED[6],
    label: 'Problem',
  },
  [AiProcessExecutionStatus.RUNNING]: {
    backgroundColor: COLOR_PALETTE.BLUE[6],
    label: 'Working',
  },
  [AiProcessExecutionStatus.PENDING]: {
    backgroundColor: COLOR_PALETTE.BLUE[5],
    label: 'Starting',
  },
  [AiProcessExecutionStatus.AWAITING_CONFIRMATION]: {
    backgroundColor: COLOR_PALETTE.ORANGE[6],
    label: 'Waiting',
  },
  [AiProcessExecutionStatus.CANCELLED]: {
    backgroundColor: COLOR_PALETTE.GRAY[6],
    label: 'Cancelled',
  },
  [AiProcessStepExecutionStatus.SKIPPED]: {
    backgroundColor: COLOR_PALETTE.GRAY[5],
    label: 'Skipped',
  },
};
